import { supabase } from '../supabaseClient'
import { estadoDelModulo, filasSync, type EstadoGuardado, type EstadoSync } from './sync-estados'

const TODOS_LOS_ITEMS_INSPECCIONES = ['GT-14']

interface InspectionForCompliance {
  id: string
  status: string
}

// Lote A: devuelve el estado que decide el módulo anterior para GT-14 (GT 9) para mostrarlo en la traza. Con
// omitirGT14 (hay una inspección v2 firmada y vigente con la pregunta de GT 9: manda v2) calcula pero no escribe.
export async function syncInspectionCompliance(companyId: string, opciones: { omitirGT14?: boolean } = {}): Promise<EstadoSync> {
  if (!companyId) return 'pendiente'

  const { data: inspections } = await supabase
    .from('inspections')
    .select('id, status')
    .eq('company_id', companyId)

  const inspectionList = (inspections ?? []) as InspectionForCompliance[]
  const finalizadas = inspectionList.filter(i => i.status === 'finalizada')

  let gt14Cumple = false

  if (finalizadas.length > 0) {
    const { count: totalChecklistItems } = await supabase
      .from('inspection_checklist_items')
      .select('id', { count: 'exact', head: true })

    if (totalChecklistItems && totalChecklistItems > 0) {
      const inspectionIds = finalizadas.map(i => i.id)

      const { data: responses } = await supabase
        .from('inspection_responses')
        .select('inspection_id')
        .in('inspection_id', inspectionIds)

      const respuestasPorInspeccion = new Map<string, number>()
      ;(responses ?? []).forEach((r: any) => {
        respuestasPorInspeccion.set(r.inspection_id, (respuestasPorInspeccion.get(r.inspection_id) ?? 0) + 1)
      })

      gt14Cumple = finalizadas.some(i => (respuestasPorInspeccion.get(i.id) ?? 0) === totalChecklistItems)
    }
  }

  const cumpleActual: string[] = []
  if (gt14Cumple) cumpleActual.push('GT-14')
  const deseado = estadoDelModulo(gt14Cumple, inspectionList.length > 0)
  if (opciones.omitirGT14) return deseado

  const { data: existing } = await supabase
    .from('checklist_item_estados')
    .select('item_id, estado, auto_source')
    .eq('company_id', companyId)
    .in('item_id', TODOS_LOS_ITEMS_INSPECCIONES)

  // Bloque 6, D: manda el módulo (sync-estados.ts): Cumple, En proceso si hay datos o Pendiente; nunca pisa un "No aplica".
  const rows = filasSync(companyId, TODOS_LOS_ITEMS_INSPECCIONES, cumpleActual, inspectionList.length > 0 ? TODOS_LOS_ITEMS_INSPECCIONES : [], (existing ?? []) as EstadoGuardado[], 'inspecciones')

  if (rows.length === 0) return deseado

  await supabase.from('checklist_item_estados').upsert(rows, { onConflict: 'company_id,item_id' })
  return deseado
}
